module.exports = __webpack_public_path__ + "static/media/replace-vehicle-yellow.78bd7918.svg";